const MODULE_PREFERENCES = {
  MOD_SHAPE: "shp",
  MOD_COLOR: "clt",
  MOD_SIZE: "sz",
  MOD_SIZE_GROUP: "sz",
  MOD_PACK_RATIO: "packratio",
};

export const isModuleEnabledForCompany = (moduleCode, companyPreferences) => {
  const preference = MODULE_PREFERENCES[moduleCode];

  if (!preference) return true;

  return Number(companyPreferences?.[preference]) === 1;
};
